import { BasketIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Basket = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <BasketIcon {...rest} size={Sizes[size]} color={fill} />;
};

Basket.displayName = 'Basket';
